export const handleShare = (addUser, addCourse) => entity => {
  if (entity.entityType === 'user') {
    addUser({
      userData: {
        uuid: entity.entityId,
        avatar_image_url: entity.avatar,
        email: entity.email,
        full_name: entity.title,
      },
    })
  } else if (entity.entityType === 'course') {
    addCourse({
      courseData: {
        uuid: entity.entityId,
        title: entity.title,
      },
    })
  } else if (entity.entityType === 'account') {
    // noop
    // Don't need to persist account records.
    // Requests for account information is proxied to canvas.
  } else {
    throw new Error('Sharing Bank with unknown entity type')
  }
}

export const getShareableUsers = fetchUsers => searchString => {
  return fetchUsers({
    searchString,
    roles: ['canvas_shareable'],
  }).then(transformUserKeys)
}

export const getUserInfo = fetchUsers => userUuids => {
  return fetchUsers({
    uuid: userUuids,
  }).then(transformUserKeys)
}

export const getShareableCourses = fetchCourses => searchString => {
  return fetchCourses({
    searchString,
    contextType: 'Course',
  }).then(transformCourseKeys)
}

export const getCourseInfo = fetchCourses => courseUuids => {
  return fetchCourses({
    uuid: courseUuids,
    contextType: 'Course',
  }).then(transformCourseKeys)
}

export const getShareableSubaccounts = (canvasCourseId, fetchSubaccounts) => searchString => {
  return fetchSubaccounts({
    canvasCourseId,
    searchString,
  }).then(transformSubaccountKeys)
}

export const getSubaccountInfo = (canvasCourseId, fetchSubaccounts) => subaccountUuids => {
  return fetchSubaccounts({
    canvasCourseId,
    uuids: subaccountUuids,
  }).then(transformSubaccountKeys)
}

const transformSubaccountKeys = data => {
  return (
    data?.json?.map(subaccount => {
      return {
        id: subaccount.id,
        name: subaccount.name,
        uuid: subaccount.uuid,
      }
    }) || []
  )
}

const transformUserKeys = data => {
  return (
    data?.json?.map(user => {
      return {
        id: user.id,
        avatar: user.avatar_image_url,
        email: user.email,
        fullName: user.full_name,
        uuid: user.uuid,
      }
    }) || []
  )
}

const transformCourseKeys = data => {
  return (
    data?.json?.map(course => {
      return {
        id: course.id,
        title: course.title,
        uuid: course.uuid,
      }
    }) || []
  )
}
